import { http } from '@frontend/fetch';
import { MerchantStatusResponse, OnboardMerchantResponse, VerticalResponse, EmbeddedLinkResponse } from './types';

const baseUrl = 'payments/sunbit';
const LOCATION_ID_HEADER = 'Location-Id';
const addLocationHeader = (locationId: string, headers: Record<string, string> = {}) => ({
  headers: { [LOCATION_ID_HEADER]: locationId, ...headers },
});

export const buyNowPayLater = {
  status: async (location: string) => {
    const response = await http.getData<MerchantStatusResponse>(
      `${baseUrl}/merchant?location_id=${location}`,
      addLocationHeader(location)
    );
    return response;
  },
  onboard: async (payload: any, locationId: string) =>
    await http.post<OnboardMerchantResponse>(
      `${baseUrl}/merchant`,
      payload,
      addLocationHeader(locationId, { 'Content-type': 'application/json' })
    ),

  getVerticals: async (locationId: string) =>
    await http.getData<VerticalResponse>(`${baseUrl}/vertical`, addLocationHeader(locationId)),
  getPortal: async (locationId: string) =>
    await http.getData<EmbeddedLinkResponse>(`${baseUrl}/embedded-portal-url`, addLocationHeader(locationId)),
};

export const getBnplTtpLink = async (locationId: string, amount: number, phoneNumber: string) => {
  const response = await http.post<{ data: { url: string } }>(
    `${baseUrl}/text-to-pay-over-time`,
    {
      amount,
      phoneNumber,
    },
    addLocationHeader(locationId, { 'Content-type': 'application/json' })
  );
  return response?.data?.url;
};
